import { inject } from '@angular/core';
import { ConfigService, IconService } from '../../core/service';
import {of} from "rxjs";

export const configFactory = () => {
  return () => {
    inject(IconService).registerIcons();
    return of(true);
  };
};
